import { render } from "./post-smtp-settings-menu.vue?vue&type=template&id=a06ecf4c&scoped=true"
import script from "./post-smtp-settings-menu.vue?vue&type=script&lang=js"
export * from "./post-smtp-settings-menu.vue?vue&type=script&lang=js"

import "./post-smtp-settings-menu.vue?vue&type=style&index=0&id=a06ecf4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a06ecf4c"]])

export default __exports__